// extracted by mini-css-extract-plugin
module.exports = {"root":"CopyLink_root__7y_BP","input":"CopyLink_input__vbubq","button":"CopyLink_button__kSBd0"};